import TextInput from './TextInput';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(TextInput);
